/* eslint-disable */
import { Coin, DecProto, IntProto } from 'cosmjs-types/cosmos/base/v1beta1/coin';
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'dymensionxyz.dymension.eibc';

/** MsgFulfillOrder defines the FulfillOrder request type. */
export interface MsgFulfillOrder {
  /** fulfiller_address is the bech32-encoded address of the account which the message was sent from. */
  fulfillerAddress: string;
  /** order_id is the unique identifier of the order to be fulfilled. */
  orderId: string;
  /** expected_fee is the nominal fee set in the order. */
  expectedFee: string;
}

/** MsgFulfillOrderResponse defines the FulfillOrder response type. */
export interface MsgFulfillOrderResponse {
}

/** MsgFulfillOrderAuthorized defines the FulfillOrderAuthorized request type. */
export interface MsgFulfillOrderAuthorized {
  /** order_id is the unique identifier of the order to be fulfilled. */
  orderId: string;
  /** rollapp_id is the unique identifier of the rollapp that the order is associated with. */
  rollappId: string;
  /** price is the price of the demand order */
  price: Coin[];
  /** amount is the amount of the IBC transfer */
  amount:
    | IntProto
    | undefined;
  /**
   * lp_address is the bech32-encoded address of the account which the authorization was granted from.
   * This account will receive the price amount at the finalization phase.
   */
  lpAddress: string;
  /**
   * operator_fee_address is an optional bech32-encoded address of an account that would collect the operator_fee_part
   * if it's empty, the operator_fee_part will go to the operator_address
   */
  operatorFeeAddress: string;
  /** expected_fee is the nominal fee set in the order. */
  expectedFee: string;
  /**
   * operator_fee_share is the share of the fee earnings that goes to the operator
   * it will be deduced from the fee of the demand order and paid out immediately
   */
  operatorFeeShare:
    | DecProto
    | undefined;
  /** settlement_validated signals if the block behind the demand order needs to be "settlement validated" or not */
  settlementValidated: boolean;
}

export interface MsgFulfillOrderAuthorizedResponse {
}

export interface MsgUpdateDemandOrder {
  /**
   * owner_address is the bech32-encoded address of the account owns the order.
   * This is expected to be the address of the order recipient.
   */
  ownerAddress: string;
  /** order_id is the unique identifier of the order to be updated. */
  orderId: string;
  /** new_fee is the new fee amount to be set in the order. */
  newFee: string;
}

export interface MsgUpdateDemandOrderResponse {
}

function createBaseMsgFulfillOrder(): MsgFulfillOrder {
  return { fulfillerAddress: '', orderId: '', expectedFee: '' };
}

export const MsgFulfillOrder = {
  encode(message: MsgFulfillOrder, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fulfillerAddress !== '') {
      writer.uint32(10).string(message.fulfillerAddress);
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId);
    }
    if (message.expectedFee !== '') {
      writer.uint32(26).string(message.expectedFee);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgFulfillOrder {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFulfillOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.fulfillerAddress = reader.string();
          break;
        case 2:
          message.orderId = reader.string();
          break;
        case 3:
          message.expectedFee = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgFulfillOrder {
    return {
      fulfillerAddress: isSet(object.fulfillerAddress) ? String(object.fulfillerAddress) : '',
      orderId: isSet(object.orderId) ? String(object.orderId) : '',
      expectedFee: isSet(object.expectedFee) ? String(object.expectedFee) : '',
    };
  },

  toJSON(message: MsgFulfillOrder): unknown {
    const obj: any = {};
    message.fulfillerAddress !== undefined && (obj.fulfillerAddress = message.fulfillerAddress);
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.expectedFee !== undefined && (obj.expectedFee = message.expectedFee);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgFulfillOrder>, I>>(object: I): MsgFulfillOrder {
    const message = createBaseMsgFulfillOrder();
    message.fulfillerAddress = object.fulfillerAddress ?? '';
    message.orderId = object.orderId ?? '';
    message.expectedFee = object.expectedFee ?? '';
    return message;
  },
};

function createBaseMsgFulfillOrderResponse(): MsgFulfillOrderResponse {
  return {};
}

export const MsgFulfillOrderResponse = {
  encode(_: MsgFulfillOrderResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgFulfillOrderResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFulfillOrderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgFulfillOrderResponse {
    return {};
  },

  toJSON(_: MsgFulfillOrderResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgFulfillOrderResponse>, I>>(_: I): MsgFulfillOrderResponse {
    const message = createBaseMsgFulfillOrderResponse();
    return message;
  },
};

function createBaseMsgFulfillOrderAuthorized(): MsgFulfillOrderAuthorized {
  return {
    orderId: '',
    rollappId: '',
    price: [],
    amount: undefined,
    lpAddress: '',
    operatorFeeAddress: '',
    expectedFee: '',
    operatorFeeShare: undefined,
    settlementValidated: false,
  };
}

export const MsgFulfillOrderAuthorized = {
  encode(message: MsgFulfillOrderAuthorized, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.orderId !== '') {
      writer.uint32(10).string(message.orderId);
    }
    if (message.rollappId !== '') {
      writer.uint32(18).string(message.rollappId);
    }
    for (const v of message.price) {
      Coin.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.amount !== undefined) {
      IntProto.encode(message.amount, writer.uint32(34).fork()).ldelim();
    }
    if (message.lpAddress !== '') {
      writer.uint32(42).string(message.lpAddress);
    }
    if (message.operatorFeeAddress !== '') {
      writer.uint32(50).string(message.operatorFeeAddress);
    }
    if (message.expectedFee !== '') {
      writer.uint32(58).string(message.expectedFee);
    }
    if (message.operatorFeeShare !== undefined) {
      DecProto.encode(message.operatorFeeShare, writer.uint32(66).fork()).ldelim();
    }
    if (message.settlementValidated === true) {
      writer.uint32(72).bool(message.settlementValidated);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgFulfillOrderAuthorized {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFulfillOrderAuthorized();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.orderId = reader.string();
          break;
        case 2:
          message.rollappId = reader.string();
          break;
        case 3:
          message.price.push(Coin.decode(reader, reader.uint32()));
          break;
        case 4:
          message.amount = IntProto.decode(reader, reader.uint32());
          break;
        case 5:
          message.lpAddress = reader.string();
          break;
        case 6:
          message.operatorFeeAddress = reader.string();
          break;
        case 7:
          message.expectedFee = reader.string();
          break;
        case 8:
          message.operatorFeeShare = DecProto.decode(reader, reader.uint32());
          break;
        case 9:
          message.settlementValidated = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgFulfillOrderAuthorized {
    return {
      orderId: isSet(object.orderId) ? String(object.orderId) : '',
      rollappId: isSet(object.rollappId) ? String(object.rollappId) : '',
      price: Array.isArray(object?.price) ? object.price.map((e: any) => Coin.fromJSON(e)) : [],
      amount: isSet(object.amount) ? IntProto.fromJSON(object.amount) : undefined,
      lpAddress: isSet(object.lpAddress) ? String(object.lpAddress) : '',
      operatorFeeAddress: isSet(object.operatorFeeAddress) ? String(object.operatorFeeAddress) : '',
      expectedFee: isSet(object.expectedFee) ? String(object.expectedFee) : '',
      operatorFeeShare: isSet(object.operatorFeeShare) ? DecProto.fromJSON(object.operatorFeeShare) : undefined,
      settlementValidated: isSet(object.settlementValidated) ? Boolean(object.settlementValidated) : false,
    };
  },

  toJSON(message: MsgFulfillOrderAuthorized): unknown {
    const obj: any = {};
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.rollappId !== undefined && (obj.rollappId = message.rollappId);
    if (message.price) {
      obj.price = message.price.map((e) => e ? Coin.toJSON(e) : undefined);
    } else {
      obj.price = [];
    }
    message.amount !== undefined && (obj.amount = message.amount ? IntProto.toJSON(message.amount) : undefined);
    message.lpAddress !== undefined && (obj.lpAddress = message.lpAddress);
    message.operatorFeeAddress !== undefined && (obj.operatorFeeAddress = message.operatorFeeAddress);
    message.expectedFee !== undefined && (obj.expectedFee = message.expectedFee);
    message.operatorFeeShare !== undefined
    && (obj.operatorFeeShare = message.operatorFeeShare ? DecProto.toJSON(message.operatorFeeShare) : undefined);
    message.settlementValidated !== undefined && (obj.settlementValidated = message.settlementValidated);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgFulfillOrderAuthorized>, I>>(object: I): MsgFulfillOrderAuthorized {
    const message = createBaseMsgFulfillOrderAuthorized();
    message.orderId = object.orderId ?? '';
    message.rollappId = object.rollappId ?? '';
    message.price = object.price?.map((e) => Coin.fromPartial(e)) || [];
    message.amount = (object.amount !== undefined && object.amount !== null)
      ? IntProto.fromPartial(object.amount)
      : undefined;
    message.lpAddress = object.lpAddress ?? '';
    message.operatorFeeAddress = object.operatorFeeAddress ?? '';
    message.expectedFee = object.expectedFee ?? '';
    message.operatorFeeShare = (object.operatorFeeShare !== undefined && object.operatorFeeShare !== null)
      ? DecProto.fromPartial(object.operatorFeeShare)
      : undefined;
    message.settlementValidated = object.settlementValidated ?? false;
    return message;
  },
};

function createBaseMsgFulfillOrderAuthorizedResponse(): MsgFulfillOrderAuthorizedResponse {
  return {};
}

export const MsgFulfillOrderAuthorizedResponse = {
  encode(_: MsgFulfillOrderAuthorizedResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgFulfillOrderAuthorizedResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFulfillOrderAuthorizedResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgFulfillOrderAuthorizedResponse {
    return {};
  },

  toJSON(_: MsgFulfillOrderAuthorizedResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgFulfillOrderAuthorizedResponse>, I>>(
    _: I,
  ): MsgFulfillOrderAuthorizedResponse {
    const message = createBaseMsgFulfillOrderAuthorizedResponse();
    return message;
  },
};

function createBaseMsgUpdateDemandOrder(): MsgUpdateDemandOrder {
  return { ownerAddress: '', orderId: '', newFee: '' };
}

export const MsgUpdateDemandOrder = {
  encode(message: MsgUpdateDemandOrder, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ownerAddress !== '') {
      writer.uint32(10).string(message.ownerAddress);
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId);
    }
    if (message.newFee !== '') {
      writer.uint32(26).string(message.newFee);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgUpdateDemandOrder {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateDemandOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.ownerAddress = reader.string();
          break;
        case 2:
          message.orderId = reader.string();
          break;
        case 3:
          message.newFee = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgUpdateDemandOrder {
    return {
      ownerAddress: isSet(object.ownerAddress) ? String(object.ownerAddress) : '',
      orderId: isSet(object.orderId) ? String(object.orderId) : '',
      newFee: isSet(object.newFee) ? String(object.newFee) : '',
    };
  },

  toJSON(message: MsgUpdateDemandOrder): unknown {
    const obj: any = {};
    message.ownerAddress !== undefined && (obj.ownerAddress = message.ownerAddress);
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.newFee !== undefined && (obj.newFee = message.newFee);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgUpdateDemandOrder>, I>>(object: I): MsgUpdateDemandOrder {
    const message = createBaseMsgUpdateDemandOrder();
    message.ownerAddress = object.ownerAddress ?? '';
    message.orderId = object.orderId ?? '';
    message.newFee = object.newFee ?? '';
    return message;
  },
};

function createBaseMsgUpdateDemandOrderResponse(): MsgUpdateDemandOrderResponse {
  return {};
}

export const MsgUpdateDemandOrderResponse = {
  encode(_: MsgUpdateDemandOrderResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgUpdateDemandOrderResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateDemandOrderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgUpdateDemandOrderResponse {
    return {};
  },

  toJSON(_: MsgUpdateDemandOrderResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgUpdateDemandOrderResponse>, I>>(_: I): MsgUpdateDemandOrderResponse {
    const message = createBaseMsgUpdateDemandOrderResponse();
    return message;
  },
};

/** Msg defines the Msg service. */
export interface Msg {
  FulfillOrder(request: MsgFulfillOrder): Promise<MsgFulfillOrderResponse>;

  FulfillOrderAuthorized(request: MsgFulfillOrderAuthorized): Promise<MsgFulfillOrderAuthorizedResponse>;

  UpdateDemandOrder(request: MsgUpdateDemandOrder): Promise<MsgUpdateDemandOrderResponse>;
}

export class MsgClientImpl implements Msg {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.FulfillOrder = this.FulfillOrder.bind(this);
    this.FulfillOrderAuthorized = this.FulfillOrderAuthorized.bind(this);
    this.UpdateDemandOrder = this.UpdateDemandOrder.bind(this);
  }

  FulfillOrder(request: MsgFulfillOrder): Promise<MsgFulfillOrderResponse> {
    const data = MsgFulfillOrder.encode(request).finish();
    const promise = this.rpc.request('dymensionxyz.dymension.eibc.Msg', 'FulfillOrder', data);
    return promise.then((data) => MsgFulfillOrderResponse.decode(new _m0.Reader(data)));
  }

  FulfillOrderAuthorized(request: MsgFulfillOrderAuthorized): Promise<MsgFulfillOrderAuthorizedResponse> {
    const data = MsgFulfillOrderAuthorized.encode(request).finish();
    const promise = this.rpc.request('dymensionxyz.dymension.eibc.Msg', 'FulfillOrderAuthorized', data);
    return promise.then((data) => MsgFulfillOrderAuthorizedResponse.decode(new _m0.Reader(data)));
  }

  UpdateDemandOrder(request: MsgUpdateDemandOrder): Promise<MsgUpdateDemandOrderResponse> {
    const data = MsgUpdateDemandOrder.encode(request).finish();
    const promise = this.rpc.request('dymensionxyz.dymension.eibc.Msg', 'UpdateDemandOrder', data);
    return promise.then((data) => MsgUpdateDemandOrderResponse.decode(new _m0.Reader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
    : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
      : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
